import http from "@/util/http.js";
const PREFIX = "/config";

export default {
	async getConfigsByRole(customConfig) {
		return await http.get(PREFIX + "/role", { customConfig });
	},
	async setConfig(config ,customConfig) {
		return await http.post(PREFIX + "/set", config, { customConfig });
	},
};
